module.exports = __webpack_public_path__ + "img/homelisticon3.8cf6c7c0.png";